<template>
    <div name="Barocare-conci-pc" class="pc-barocare-conci">
        <!-- 메인 페이지일 때만 렌더링되는 부분 -->
        <template v-if="!isSubPage">
            <BarocareConciHeader />
            <BarocareConciHome />
            <BarocareConciIntro />
            <BarocareConciProduct />
            <BarocareConciHospital />
            <BarocareConciBanner />
            <BarocareConciInquiry />
            <BarocareConciFooter />
            <BarocareConciPopup />
        </template>

        <!-- 서브 페이지일 때만 렌더링되는 라우터 뷰 -->
        <router-view v-if="isSubPage"></router-view>
    </div>
</template>

<script>
(function(){var w=window;if(w.ChannelIO){return w.console.error("ChannelIO script included twice.");}var ch=function(){ch.c(arguments);};ch.q=[];ch.c=function(args){ch.q.push(args);};w.ChannelIO=ch;function l(){if(w.ChannelIOInitialized){return;}w.ChannelIOInitialized=true;var s=document.createElement("script");s.type="text/javascript";s.async=true;s.src="https://cdn.channel.io/plugin/ch-plugin-web.js";var x=document.getElementsByTagName("script")[0];if(x.parentNode){x.parentNode.insertBefore(s,x);}}if(document.readyState==="complete"){l();}else{w.addEventListener("DOMContentLoaded",l);w.addEventListener("load",l);}})();

import BarocareConciHeader from '@/components/pc_barocare_conci/BarocareConciHeader';
import BarocareConciHome from '@/components/pc_barocare_conci/BarocareConciHome';
import BarocareConciIntro from '@/components/pc_barocare_conci/BarocareConciIntro';
import BarocareConciProduct from '@/components/pc_barocare_conci/BarocareConciProduct';
import BarocareConciHospital from '@/components/pc_barocare_conci/BarocareConciHospital';
import BarocareConciBanner from '@/components/pc_barocare_conci/BarocareConciBanner';
import BarocareConciInquiry from '@/components/pc_barocare_conci/BarocareConciInquiry';
import BarocareConciFooter from '@/components/pc_barocare_conci/BarocareConciFooter';
import BarocareConciPopup from '@/components/pc_barocare_conci/BarocareConciPopup';

export default {
    // name: 'BarocareConciPc',
    name: 'PcBarocareConci',
    components: {
        BarocareConciHeader,
        BarocareConciHome,
        BarocareConciIntro,
        BarocareConciProduct,
        BarocareConciHospital,
        BarocareConciBanner,
        BarocareConciInquiry,
        BarocareConciFooter,
        BarocareConciPopup
    },
    data() {
        return {
            // 현재 경로가 서브 페이지인지를 체크
            isSubPage: this.$route.path.includes('/sub')
        };
    },
    watch: {
        // 경로가 변경될 때마다 isSubPage 값을 업데이트
        '$route.path'(newPath) {
            this.isSubPage = newPath.includes('/sub');
        }
    },
    mounted() {
        ChannelIO('boot', {
            "pluginKey": "90e69520-1088-43c6-a1cc-3019437a9be8",

        });

        // 페이지가 로드되면 스크롤을 맨 위로
        $('html').animate({
            scrollTop: 0
        }, 300)
    }
}
</script>

<style lang="scss">
@import "../../../styles/PcBarocareConci";
</style>



// WEBPACK FOOTER //
// src/page/concierge/pc/PcBarocareConci.vue